import React, { useState, useRef, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

const CopyableSystemId = ({ data, url }: { data: string; url?: string }) => {
    const [isTooltip, setIsTooltip] = useState('');

    const target = useRef(null);

    let timer: NodeJS.Timeout | undefined;
    const handleCloseTooltip = () => {
        timer = setTimeout(() => setIsTooltip(''), 750);
    };

    useEffect(() => {
        // Clear timer on unmount
        return () => {
            clearTimeout(timer!);
        };
    }, [timer]);

    return (
        <div className="copyable-systemId">
            <OverlayTrigger
                show={isTooltip === data}
                overlay={(props) => {
                    return (
                        <Tooltip id="copyableTooltip" {...props}>
                            Copied
                        </Tooltip>
                    );
                }}
                placement="top"
            >
                {url ? (
                    <Link ref={target} to={url}>
                        {data}
                    </Link>
                ) : (
                    <span ref={target}>{data}</span>
                )}
            </OverlayTrigger>
            <span
                className="iconButton m-auto pl-2"
                onClick={() => {
                    navigator.clipboard.writeText(`${data}`);
                    setIsTooltip(data);
                    handleCloseTooltip();
                }}
            >&nbsp;
                <FontAwesomeIcon icon={faClone} size="sm" />
            </span>
        </div>
    );
};

export default CopyableSystemId;
